export const VERIFY_TOKEN = 'VERIFY_TOKEN';
export const VERIFICATION_SUCCESS = 'VERIFICATION_SUCCESS';
export const VERIFICATION_FAIL = 'VERIFICATION_FAIL';
export const CLOSE_SCAN_MODAL = 'CLOSE_SCAN_MODAL';
export const OPEN_SCAN_MODAL = 'OPEN_SCAN_MODAL';
export const SET_CURR_OPENED_MODAL =  'SET_CURR_OPENED_MODAL' 
export const SET_ORDER_MODAL_STATE = 'SET_ORDER_MODAL_STATE'